module.exports = __webpack_public_path__ + "static/media/sidewinder.f6c23dff.png";